import gql from "graphql-tag";
import PinnablePostFields from "../../fragments/engagement/PinnablePostFields";

export default gql`
  mutation UnpinPost($postId: ObjectID!) {
    unpinPost(postId: $postId) {
      ...PinnablePostFields
    }
  }

  ${PinnablePostFields}
`;
